import styled from '@emotion/styled';

export const NewsPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
`;

export const BackButtonContainer = styled.div`
  margin-bottom: 24px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-direction: row;

  @media (max-width: 1400px) {
    flex-direction: column;
  }
`;

export const ArticleDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  img {
    max-width: 500px;
    height: auto;

    &:first-of-type {
      max-width: 700px;
    }
  }

  @media (min-width: 1200px) {
    width: 75%;
  }
  @media (max-width: 1400px) {
    width: 100%;
  }
`;

export const MoreArticlesContainer = styled.div`
  width: 100%;
  margin-top: 24px;

  @media (min-width: 1400px) {
    width: 25%;
    margin-left: 24px;
    margin-top: 0;
  }
`;
